export default "__VITE_ASSET__1jWSqAa4__"